import { InfoBox } from '@selina-finance/ui';

interface IErrorContainer {
    formikProps: any;
    additionalErrors?: string[];
    hardStopError?: string;
}

const ErrorContainer = ({
    formikProps,
    additionalErrors,
    hardStopError,
}: IErrorContainer) => {
    if (hardStopError) {
        return (
            <div className='mb-3'>
                <InfoBox type='error'>{hardStopError}</InfoBox>
            </div>
        );
    }

    const getNumberOfErrors = (formikProps: any): number => {
        const countErrors = (errors: any, touched: any): number => {
            let count = 0;

            for (const key in errors) {
                if (!Object.prototype.hasOwnProperty.call(errors, key))
                    continue;

                const errorVal = errors[key];
                const touchedVal = touched?.[key];

                if (typeof errorVal === 'string' && touchedVal) {
                    count++;
                } else if (
                    typeof errorVal === 'object' &&
                    errorVal !== null &&
                    touchedVal
                ) {
                    count += countErrors(errorVal, touchedVal);
                }
            }

            return count;
        };

        return countErrors(formikProps.errors, formikProps.touched);
    };

    const errorLength = getNumberOfErrors(formikProps);

    return errorLength > 0 ? (
        <div className='mb-3'>
            <InfoBox type='error'>
                Please fix the{' '}
                {errorLength > 1
                    ? errorLength + ' highlighted errors'
                    : '1 highlighted error'}{' '}
                to continue
                <ul className='ml-6 list-disc'>
                    {additionalErrors &&
                        additionalErrors.map((it, index) =>
                            it ? <li key={index}>{it}</li> : null,
                        )}
                </ul>
            </InfoBox>
        </div>
    ) : (
        <></>
    );
};

export default ErrorContainer;
